import { DataTableFilterMetaData } from "primevue/datatable"
import { FilterMatchMode, FilterOperator } from "primevue/api"
import { ref } from "vue"

export default function tabelaProjetos() {
  const filtrosTabela = ref({
    nome_projeto: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    codigo: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.CONTAINS },
      ] as DataTableFilterMetaData[],
    },
    usuarios_responsaveis: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.IN },
      ] as DataTableFilterMetaData[],
    },
  })

  return {
    filtrosTabela,
  }
}
